import axios from 'axios';

// Lokal steht in frontend/.env die volle Adresse (http://localhost:8000).
// Auf dem Server ist der Wert bewusst leer: Oberfläche und API laufen unter
// derselben Domain, die Anfragen gehen also an /api auf demselben Host.
// Der Fallback auf '' verhindert, dass bei fehlender Variable die Adresse
// "undefined/api" entsteht – das wäre der klassische stille Deployment-Fehler.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? '';
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

export const TOKEN_KEY = 'fd_auth_token';
export const USER_KEY = 'fd_auth_user';

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Wird von AuthProvider gesetzt: was passieren soll, wenn der Server eine
// Anfrage mangels Berechtigung ablehnt. Liegt hier, weil Axios keine
// React-Hooks kennt.
let berechtigungsWechselHandler = null;
export const setBerechtigungsWechselHandler = (fn) => { berechtigungsWechselHandler = fn; };

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const path = window.location.pathname;
      if (!path.startsWith('/login') && !path.startsWith('/onboarding')) {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
        window.location.href = '/login';
      }
    }
    // 403 mit diesem Kennzeichen heißt: Die Rechte wurden geändert, während
    // dieser Browser noch mit dem alten Stand arbeitet. Andere 403 (z. B.
    // fremde Kostenstelle, gesperrter Zeitraum) sind fachliche Ablehnungen
    // und werden ganz normal als Meldung angezeigt.
    if (error.response?.status === 403 && error.response.headers?.['x-perm-refresh']) {
      if (berechtigungsWechselHandler) berechtigungsWechselHandler();
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export const extractError = (err) => {
  if (err?.response?.data?.detail) {
    if (Array.isArray(err.response.data.detail)) {
      return err.response.data.detail.map(d => d.msg || d).join(', ');
    }
    return err.response.data.detail;
  }
  return err?.message || 'Unbekannter Fehler';
};
